import { render, staticRenderFns } from "./CheckVersion.vue?vue&type=template&id=6f8ca807&"
import script from "./CheckVersion.vue?vue&type=script&lang=ts&"
export * from "./CheckVersion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f8ca807')) {
      api.createRecord('6f8ca807', component.options)
    } else {
      api.reload('6f8ca807', component.options)
    }
    module.hot.accept("./CheckVersion.vue?vue&type=template&id=6f8ca807&", function () {
      api.rerender('6f8ca807', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/utils/CheckVersion.vue"
export default component.exports